
import React, { useContext, useState, useEffect } from 'react';
import _ from 'lodash';
import { MetadataContent } from '@jutro/legacy/uiconfig';
import { useTranslator } from '@jutro/locale';
import { withRouter } from 'react-router-dom';
import { MLModalService } from 'ml-portals-services-react';
import { ClaimService } from 'gw-capability-claim';
import { useAuthentication } from '@xengage/gw-digital-auth-react';
import { MLAlertGroupComponent } from 'ml-components-common-react';
import { MLProductCodeUtil } from 'ml-portals-util-js';
import { useDataRefresh } from '@xengage/gw-portals-viewmodel-react';

import MLClaimDetailsKeyContact from '../../components/MLClaimDetailsKeyContact/MLClaimDetailsKeyContact'
import MLClaimDetailsDetailedSummary from '../../components/MLClaimDetailsDetailedSummary/MLClaimDetailsDetailedSummary';
import MLClaimDetailsPAInvolved from '../../components/MLClaimDetailsPAInvolved/MLClaimDetailsPAInvolved'
import MLClaimDetailsProperty from '../../components/MLClaimDetailsProperty/MLClaimDetailsProperty'
import MLClaimDetailsHOInvolved from '../../components/MLClaimDetailsHOInvolved/MLClaimDetailsHOInvolved'
import MLClaimDetailsVehicles from '../../components/MLClaimDetailsVehicles/MLClaimDetailsVehicles'
import MLClaimDetailsSelfServe from '../../components/MLClaimDetailsSelfServe/MLClaimDetailsSelfServe'
import MLClaimDetailsPayments from '../../components/MLClaimDetailsPayments/MLClaimDetailsPayments'
import MLClaimDetailsCoverages from '../../components/MLClaimDetailsCoverages/MLClaimDetailsCoverages'
import MLClaimDetailsDocsReceived from '../../components/MLClaimDetailsDocsReceived/MLClaimDetailsDocsReceived'
import MLClaimDetailsDocsSent from '../../components/MLClaimDetailsDocsSent/MLClaimDetailsDocsSent'

import metadata from './MLClaimDetails.metadata.json5';
import messages from './MLClaimDetails.messages';
import styles from './MLClaimDetails.module.scss';

import { IntlContext } from '@jutro/legacy/locale';

function MLClaimDetails(props) {
    const {
        match
    } = props;
    const translator = useTranslator();
    const intl = useContext(IntlContext)
    const { authHeader } = useAuthentication();
    const ModalService = MLModalService();
    const { refreshData } = useDataRefresh();

    const claimNumber = match.params.claimNumber;
    const [claim, updateClaim] = useState();
    const [insuredVehicleIncident, updateInsuredVehicleIncident] = useState();
    const [thirdPartyVehicleIncidents, updateThirdPartyVehicleIncidents] = useState();
    const [isVehicleRepairable, updateIsVehicleRepairable] = useState();
    const [isServiceRequestMade, updateIsServiceRequestMade] = useState();
    const [propertyOwner, updatePropertyOwner] = useState();
    const [insured, updateInsured] = useState();
    const [activityData, updateActivityData] = useState();

    const isPersonalAuto = (_claim) => {
        if(_claim){
            return MLProductCodeUtil.isPersonalAuto(_claim.policy.policyType);
        }
        if(!claim){
            return false;
        }
        return MLProductCodeUtil.isPersonalAuto(claim.policy.policyType);
    };

    const getContactByRole = (claimDetails, contactRole) => {
        return claimDetails.claimContacts.find((contact) => contact.contactRoles.find((role) => role === contactRole));
    };

    const formatCurrency = (value) => {
        let formattedAmount = '';
        if (value) {
            const { amount, currency } = value;
            if (!_.isUndefined(amount) && currency) {
                formattedAmount = intl.formatNumber(amount, { style: 'currency', currency: currency });
            }
        }
        return formattedAmount;
    };

    const getCCCServiceProvider = (_claim) => {
        return _.find(_claim.serviceRequests_ML, (service) => _.includes(service.services, 'autoapprccc'));
    };

    const getAddressToDisplay = (address) => {
        if (address) {
            return `${address.addressLine1} ${address.city}, ${address.state} ${address.postalCode}`;
        }
    };

    const prepareActivityData = (_claim) => {
        const _activityData = [];
        const cccServiceProvider = getCCCServiceProvider(_claim);

        if (cccServiceProvider && cccServiceProvider.RentalReservationNumber_ML) {
            _activityData.push({
                date: cccServiceProvider.RentalReservationCreationDate_ML,
                message: translator(messages.RentalReservation, {
                    resNumber: cccServiceProvider.RentalReservationNumber_ML,
                    rentBranchAddress: getAddressToDisplay(cccServiceProvider.RentalReservationAddress_ML),
                    phoneNumber: cccServiceProvider.RentalBranchNumber_ML
                })
            });
            if (cccServiceProvider.RentalReservationStatus_ML === 'closed') {
                _activityData.push({
                    message: translator(messages.RentalCompleted)
                });
            }
        }
        _claim.payments_ML?.forEach((payment) => {
            _activityData.push({
                date: new Date(payment.date),
                message: translator(messages.PaymentForCoverage, {
                    amount: formatCurrency(payment.amountPaid),
                    coverage: payment.coverageName_ML
                })
            });
        });
        return _activityData;
    };

    useEffect(() => {
        const claimDetailsPromise = ClaimService.getClaimDetail(claimNumber, authHeader);
        ModalService.showProgressDialog(messages.RetrievingClaimDetails, claimDetailsPromise);
        claimDetailsPromise.then((claimDetails) => {
            if (typeof ClaimService.addRecentlyViewedClaim === 'function') {
                ClaimService.addRecentlyViewedClaim(claimNumber);
            }
            if (isPersonalAuto(claimDetails)) {
                const _insuredVehicleIncident = claimDetails.lobs.personalAuto.vehicleIncidents.find((incident) => incident.vehicleLossParty_ML === 'insured');
                updateInsuredVehicleIncident(_insuredVehicleIncident);
                updateThirdPartyVehicleIncidents(claimDetails.lobs.personalAuto.vehicleIncidents.filter((incident) => incident.vehicleLossParty_ML !== 'insured'));
                if (_insuredVehicleIncident?.totalLossProbabilty_ML) {
                    updateIsVehicleRepairable(_insuredVehicleIncident.totalLossProbabilty_ML === 'repairable');
                }
                if (_insuredVehicleIncident) {
                    updateIsServiceRequestMade(_insuredVehicleIncident.isApprCCCServiceRequestMade);
                }
            } else {
                updatePropertyOwner(getContactByRole(claimDetails, 'insured'));
            }
            updateInsured(getContactByRole(claimDetails, 'insured'));
            updateActivityData(prepareActivityData(claimDetails));
            claimDetails.documents = claimDetails.documents.filter((doc) => !doc.isDocumentYouSentUs_ML);
            updateClaim(claimDetails);
        }).catch((error) => {
            console.error('error retrieving claim details', error);
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const isTowingOrGlassLossCause = () => {
        return !!(claim?.lossCause === 'towing_ml' || claim?.lossCause === 'glass_ml');
    };

    const isSelfServiceAvailable = () => {
        if (isPersonalAuto()) {
            const isCollisionCoverage = insuredVehicleIncident?.vehicle?.coverages?.some((coverage) =>
                coverage.type_ML === 'PACollisionCov'
            );
            const isComprehensiveCoverage = insuredVehicleIncident?.vehicle?.coverages?.some((coverage) =>
                coverage.type_ML === 'PAComprehensiveCov'
            );
            return !!(isCollisionCoverage && isComprehensiveCoverage && !isTowingOrGlassLossCause());
        }
        return false;
    };


    const overrides = {
        subHeader: {
            content: <>{translator(messages.SubHeader, {
                claimNumber: _.get(claim, 'claimNumber'),
                policyNumber: _.get(claim, 'policy.policyNumber')
            })}</>
        },
        claimDetailsKeyContact: {
            mainContact: _.get(claim, 'mainContact', {}),
            adjuster: _.get(claim, 'adjuster', {}),
            serviceRequests: _.get(claim, 'serviceRequests_ML', []),
            isPersonalAuto: isPersonalAuto(),
        },
        claimsDetailsDetailedSummary: {
            claim: claim
        },
        claimDetailsPAInvolved: {
            visible: isPersonalAuto(),
            insuredVehicleIncident,
            thirdPartyVehicleIncidents: thirdPartyVehicleIncidents || []
        },
        claimDetailsHOInvolved: {
            visible: !isPersonalAuto(),
            propertyOwner
        },
        claimDetailsVehicles: {
            visible: isPersonalAuto(),
            insuredVehicleIncident,
            thirdPartyVehicleIncidents: thirdPartyVehicleIncidents || []
        },
        claimDetailsproperty: {
            visible: !isPersonalAuto(),
            lossLocation: claim?.lossLocation
        },
        claimDetailsDocsSent: {
            claim,
            refreshData
        },
        claimDetailsDocsReceived: {
            docs: claim?.documents
        },
        claimDetailsSelfServe: {
            policyBaseState: claim?.policy?.policyBaseState,
            insuredVehicleIncident,
            claimNumber,
            claimLossCause: claim?.lossCause,
            mainContact: claim?.mainContact,
            isServiceRequestMade,
            isVehicleRepairable,
            isSelfServiceAvailable: isSelfServiceAvailable()
        },
        claimDetailsPayments: {
            payments: claim?.payments_ML || [],
            insured
        },
        claimDetailsCoverages: {
            claim,
            isPersonalAuto: isPersonalAuto(),
            insuredVehicleIncident
        }
    };
    const resolvers = {
        resolveClassNameMap: styles,
        resolveComponentMap: {
            MLAlertGroupComponent,
            MLClaimDetailsKeyContact,
            MLClaimDetailsDetailedSummary,
            MLClaimDetailsPAInvolved,
            MLClaimDetailsHOInvolved,
            MLClaimDetailsVehicles,
            MLClaimDetailsProperty,
            MLClaimDetailsDocsSent,
            MLClaimDetailsDocsReceived,
            MLClaimDetailsSelfServe,
            MLClaimDetailsPayments,
            MLClaimDetailsCoverages
        },
        resolveCallbackMap: {
        }
    };

    return <MetadataContent uiProps={metadata.pageContent} overrideProps={overrides} {...resolvers} />;
}

export default withRouter(MLClaimDetails);
